// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1_bfV","cls2":"AccountMenu-cls2_xeb AccountMenu-cls1_bfV"};